var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"context--text weight-600 primary--text size-10 spacing-xs px-2 py-1",attrs:{"rounded":"sm","color":"sheet"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }